import React from "react";

const LightningIcon = ({ fillColor = "#D0D0D0" }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<path d="M7.25 15.25L6.5 14.75L7.25 9.5H4L6.25 2L11.25 1.25L8.75 6.5H13L7.25 15.25Z" fill={fillColor} />
	</svg>
);
export default React.memo(LightningIcon);
